import type { ComponentType, SVGProps } from 'react'
import {
  IconAddress,
  IconCommission,
  IconDriver,
  IconEquipment,
  IconGridMenu,
  IconHome,
  IconIntegration,
  IconInvoice,
  IconOrders,
  IconSettings,
  IconTrip,
  IconVendor,
} from './sidebar-custom-icons'

export type SidebarSvgProps = SVGProps<SVGSVGElement> & { size?: number }

export const sidebarNavIconByHref: Record<string, ComponentType<SidebarSvgProps>> = {
  home: IconHome,
  order: IconOrders,
  trip: IconTrip,
  'carrier-trip': IconTrip,
  invoice: IconInvoice,
  factoring: IconInvoice,
  receivables: IconInvoice,
  payables: IconInvoice,
  carrier: IconTrip,
  vendor: IconVendor,
  'driver-payables': IconDriver,
  address: IconAddress,
  equipment: IconEquipment,
  driver: IconDriver,
  integration: IconIntegration,
  commission: IconCommission,
  settings: IconSettings,
}

export function SidebarNavIcon({ href, size = 22 }: { href: string; size?: number }) {
  const Cmp = sidebarNavIconByHref[href] ?? IconGridMenu
  return <Cmp size={size} aria-hidden />
}

export {
  IconChevronDown,
  IconChevronUp,
  IconGridMenu,
  IconLogout,
  IconPlusRoute,
  IconPlusSheet,
} from './sidebar-custom-icons'
